import type { ReactNode } from "react";

/**
 * Session context placeholder — auth state lives in Zustand + useAuthGuard.
 * Expand here if we need explicit session context for deep trees.
 */
export function SessionProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
